import ticketImg from '../../components/atomic/icons/ticket/ticket.png';
import './TicketIcon.css';

/** From Figma icon_ticket (154:32744) — 402 1014.7 161×131.81, rotate −17.63°. */
export function TicketIcon() {
  return (
    <img
      className="tickets-ticket-icon"
      src={ticketImg}
      alt=""
      draggable={false}
      aria-hidden
    />
  );
}
